export const environment = {
  production: true,
  gatewayUrl: 'https://heimdall.dobossy.com',
  //gatewayUrl: 'http://192.168.1.21:8001',
  //gatewayUrl: 'http://localhost:8001',
};
